import { render } from "./mchristophBrand.vue?vue&type=template&id=32e97f61&scoped=true"
import script from "./mchristophBrand.vue?vue&type=script&lang=js"
export * from "./mchristophBrand.vue?vue&type=script&lang=js"

import "./mchristophBrand.vue?vue&type=style&index=0&id=32e97f61&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e97f61"]])

export default __exports__